import {
  Checkbox,
  FormControlLabel,
  FormControl,
  checkboxClasses,
} from "@mui/material";
import React, { FC } from "react";
import { IFilterItem, IFilterValue } from "../../model/types";

interface ITableFilterCheckboxProps {
  filter: IFilterItem<boolean>;
  onChange: (v: IFilterValue<boolean>) => void;
}
const TableFilterCheckbox: FC<ITableFilterCheckboxProps> = ({
  filter: { name, value, title },
  onChange,
}) => {
  return (
    <FormControl
      sx={{
        transition: "all 0.3s",
        flexDirection: "row",
        alignItems: "center",
        minWidth: "unset",
      }}
    >
      <FormControlLabel
        sx={{
          marginLeft: 0,
          marginRight: 0,
          borderRadius: (theme) => theme.spacing(4.5),
          padding: (theme) => theme.spacing(1.75, 3, 2),
          ["&:hover"]: {
            backgroundColor: (theme) => theme.palette.grey[100],
          },
          ["&:active"]: {
            backgroundColor: (theme) => theme.palette.grey[300],
          },
          ["& *"]: {
            lineHeight: 1.25,
            fontWeight: value ? "600!important" : undefined,
          },
          [`& .${checkboxClasses.root}`]: {
            ["&:hover"]: {
              backgroundColor: "transparent!important",
            },
            ["&:active"]: {
              backgroundColor: "transparent",
            },
          },
        }}
        control={
          <Checkbox
            sx={{
              [`&.${checkboxClasses.checked}, &.${checkboxClasses.indeterminate}`]:
                {
                  ["&:hover"]: {
                    color: (theme) => theme.palette.primary.main,
                    backgroundColor: "transparent",
                  },
                  ["&:active"]: {
                    color: (theme) => theme.palette.primary.main,
                    backgroundColor: "transparent",
                  },
                },

              [`&:not(.${checkboxClasses.checked}, .${checkboxClasses.indeterminate})`]:
                {
                  ["&:hover"]: {
                    color: (theme) => theme.palette.grey[500],
                  },
                  ["&:active"]: {
                    color: (theme) => theme.palette.grey[500],
                  },
                },
            }}
            name={name}
            onChange={(e) => onChange({ name, value: e.target.checked })}
            checked={!!value}
          />
        }
        label={title}
      />
    </FormControl>
  );
};

export default TableFilterCheckbox;
